import { MijnRoute } from '../../mijn-navigatie.model';

export const BUDGETS: MijnRoute = {
    path: 'budgetten',
    navigationEvent: 'toBudgets',
    regex: /^\/budgetten$/,
    webcomponent: 'mijn-budget-webcomponent'
};
